export const assessmentsConstants = {

    // REQUEST_ASSESSMENT_LIST 
    REQUEST_ASSESSMENT_LIST: 'REQUEST_ASSESSMENT_LIST',
    RECEIVE_ASSESSMENT_LIST: 'RECEIVE_ASSESSMENT_LIST',
    ASSESSMENT_LIST_ERROR: 'ASSESSMENT_LIST_ERROR',

    // REQUEST_RESPONDENTS_ASSESSMENT
    REQUEST_RESPONDENTS_ASSESSMENT: 'REQUEST_RESPONDENTS_ASSESSMENT',
    RECEIVE_RESPONDENTS_ASSESSMENT: 'RECEIVE_RESPONDENTS_ASSESSMENT',
    RESPONDENTS_ASSESSMENT_ERROR: 'RESPONDENTS_ASSESSMENT_ERROR',

    // REQUEST_ASSESSMENT_SUBMIT
    REQUEST_ASSESSMENT_SUBMIT:'REQUEST_ASSESSMENT_SUBMIT',
    RECEIVE_ASSESSMENT_SUBMIT:'RECEIVE_ASSESSMENT_SUBMIT',
    ASSESSMENT_SUBMIT_ERROR:'ASSESSMENT_SUBMIT_ERROR',

};



// WEBPACK FOOTER //
// ./src/_constants/assessment.constants.js